import { useState, useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter, usePathname } from 'src/routes/hooks';

import { SplashScreen } from 'src/components/loading-screen';

import { UnauthorizedView } from 'src/sections/error';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: React.ReactNode;
};

export function ClientAuthGuard({ children }: AuthGuardProps) {
  const router = useRouter();
  const pathname = usePathname();

  const { authenticated, loading } = useAuthContext();

  const [isChecking, setIsChecking] = useState(true);

  const checkPermissions = useCallback(async (): Promise<void> => {
    if (loading) return;

    // if (!authenticated) {
    //   const queryString = new URLSearchParams({ returnTo: pathname }).toString();
    //   router.replace(`${paths.error.unauthorized}?${queryString}`);
    //   return;
    // }

    setIsChecking(false);
  }, [loading]);

  useEffect(() => {
    checkPermissions();
  }, [checkPermissions]);

  if (isChecking) {
    return <SplashScreen />;
  }

  if (!authenticated) {
    return <UnauthorizedView />;
  }

  return <>{children}</>;
}
